import { useEffect, useState } from "react";

import { useAppStore } from "./useAppStore";

/** The config_flags snapshot normally arrives moments after the WebSocket
 * connects. If it never does (dropped connection, backend hiccup, endless
 * reconnect backoff), callers stop waiting instead of spinning forever. */
export const CONFIG_FLAGS_TIMEOUT_MS = 5000;

/** Tracks whether the first config_flags snapshot is still pending.
 * `isWaiting` is true until flags load or the timeout elapses; `timedOut`
 * is true when we gave up without ever receiving them. */
export const useConfigFlagsWait = () => {
  const appStore = useAppStore();
  const isLoaded = Boolean(appStore?.isConfigFlagsLoaded);
  const [waitTimedOut, setWaitTimedOut] = useState(false);

  useEffect(() => {
    if (isLoaded) {
      return;
    }

    const timer = setTimeout(
      () => setWaitTimedOut(true),
      CONFIG_FLAGS_TIMEOUT_MS,
    );
    return () => clearTimeout(timer);
  }, [isLoaded]);

  return {
    isWaiting: !isLoaded && !waitTimedOut,
    timedOut: !isLoaded && waitTimedOut,
  };
};
